import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { CheckboxCustom } from "@components/atoms";
import { filterNotEmptyArrayItems } from "@utils/misc";
import React from "react";
import { useIntl } from "react-intl";
import { AddressForm } from "../AddressForm";
import { AddressGridSelector } from "../AddressGridSelector";
import * as S from "./styles";

var CheckoutBillingAddress = function CheckoutBillingAddress(_ref) {
  var billingErrors = _ref.billingErrors,
      selectedUserAddressId = _ref.selectedUserAddressId,
      userAddresses = _ref.userAddresses,
      _ref$billingAsShippin = _ref.billingAsShippingAddress,
      billingAsShippingAddress = _ref$billingAsShippin === void 0 ? true : _ref$billingAsShippin,
      checkoutBillingAddress = _ref.checkoutBillingAddress,
      countries = _ref.countries,
      billingFormRef = _ref.billingFormRef,
      billingFormId = _ref.billingFormId,
      setBillingAddress = _ref.setBillingAddress,
      billingAsShippingPossible = _ref.billingAsShippingPossible,
      setBillingAsShippingAddress = _ref.setBillingAsShippingAddress,
      userId = _ref.userId,
      newAddressFormId = _ref.newAddressFormId;
  var intl = useIntl();
  var adresses = (userAddresses === null || userAddresses === void 0 ? void 0 : userAddresses.filter(filterNotEmptyArrayItems).map(function (address) {
    return {
      address: _objectSpread({}, address, {
        isDefaultBillingAddress: address.isDefaultBillingAddress || false,
        isDefaultShippingAddress: address.isDefaultShippingAddress || false,
        phone: address.phone || undefined
      }),
      id: (address === null || address === void 0 ? void 0 : address.id) || "",
      onSelect: function onSelect() {
        return null;
      }
    };
  })) || [];
  return React.createElement(S.Wrapper, null, React.createElement("section", null, React.createElement(S.Title, {
    "data-cy": "checkoutPageSubtitle"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Billing address",
    "id": "@next.components.organisms.CheckoutBillingAddress.CheckoutBillingAddress.2428885633"
  }, "id", "@next.components.organisms.CheckoutBillingAddress.CheckoutBillingAddress.2428885633"))), billingAsShippingPossible && React.createElement(CheckboxCustom, {
    "data-cy": "checkoutPaymentBillingAsShippingCheckbox",
    name: "billing-same-as-shipping",
    checked: billingAsShippingAddress,
    onChange: function onChange() {
      return setBillingAsShippingAddress(!billingAsShippingAddress);
    }
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Same as shipping address",
    "id": "@next.components.organisms.CheckoutBillingAddress.CheckoutBillingAddress.3912924864"
  }, "id", "@next.components.organisms.CheckoutBillingAddress.CheckoutBillingAddress.3912924864"))), !billingAsShippingAddress && React.createElement(React.Fragment, null, billingAsShippingPossible && React.createElement(S.Divider, null), userAddresses ? React.createElement(AddressGridSelector, {
    formId: billingFormId,
    formRef: billingFormRef,
    addresses: adresses,
    selectedAddressId: selectedUserAddressId,
    countriesOptions: countries === null || countries === void 0 ? void 0 : countries.filter(filterNotEmptyArrayItems),
    userId: userId,
    errors: billingErrors,
    onSelect: function onSelect(address, id) {
      return setBillingAddress(address, undefined, id);
    },
    newAddressFormId: newAddressFormId
  }) : React.createElement(AddressForm, {
    formId: billingFormId,
    formRef: billingFormRef,
    countriesOptions: countries.filter(filterNotEmptyArrayItems),
    address: checkoutBillingAddress || undefined,
    handleSubmit: function handleSubmit(address) {
      return setBillingAddress(address, address === null || address === void 0 ? void 0 : address.email);
    },
    includeEmail: !billingAsShippingPossible,
    backendValidationErrors: billingErrors
  }))));
};

export { CheckoutBillingAddress };